import { React} from 'react'
import { Image } from 'react-native-web';
import {Linking} from "react-native";
import { 
    Nav, 
    Bars, 
    NavMenu,
    NavLink
    } from './NavbarElements';

    const onPressSocialBtnTwitter = () => {
        Linking.openURL("https://twitter.com/OctaTechnology").catch(err => console.error("Couldn't load page", err));
    };

    const NavBar = ({toggle}) =>{
        return (

            <div>
                <Nav>
                    <NavLink to="/">
                        <Image source={{ uri: "../logo.png" }} style={{ width: 16,height: 16,tintColor: "#000"}}  alt='app logo'/>
                    
                    </NavLink>

                     <Bars onClick={toggle}/> 
                   
                    <NavMenu>
                        <NavLink to="/contact" activeStyle>
                            Contact
                        </NavLink>
                        <NavLink to="/questions" activeStyle>
                            Questions?
                        </NavLink>
                        <NavLink to="/legal" onClick={toggle}>
                            Legal
                        </NavLink> 
                        
                        <div className='social-icons'>
                        <img src={require('../../images/social-twitter.png')} onClick={onPressSocialBtnTwitter} />
                        </div>

                    </NavMenu>

                    
                </Nav>
            </div>
            
        );
    };

export  default NavBar;
